import { GroqImage } from '@/helpers/Image';
import { IArticle } from '@/lib/blog';
import { cn, getDescription, getTitle } from '@/lib/utils';
import Link from 'next/link';

export default function BlogCardMD({
  article,
  className,
  enableImage = true,
  enableDescription = true,
}: {
  article: IArticle;
  className?: string;
  enableImage?: boolean;
  enableDescription?: boolean;
}) {
  const slug = article?.settings?.slug?.current;
  return (
    <div
      className={cn(
        'lg:w-[40.375rem] w-full flex flex-col gap-[2.25rem]',
        className
      )}
      key={article._id}
    >
      <div className="flex flex-col gap-[1.75rem]">
        {enableImage && (
          <Link
            href={slug}
            className="h-[22.5rem] w-full overflow-clip block group"
          >
            {article.mainImage && (
              <GroqImage
                src={article.mainImage}
                alt={article.mainImage.name || 'Article image'}
                className="!w-full !h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            )}
          </Link>
        )}

        <span className="block text-secondary font-roboto text-[1.375rem] font-semibold tracking-[-0.04125rem] uppercase mb-0">
          {article?.categories[0]}
        </span>

        <Link href={slug} className="flex flex-col gap-[1.75rem] group">
          <h3 className="text-[3rem] tracking-[-0.09rem] group-hover:opacity-70 duration-500 transition-opacity">
            {getTitle({ text: article.title })}
          </h3>

          {enableDescription && (
            <p className="font-roboto text-white/80 font-medium tracking-[-0.06rem] leading-[160%] line-clamp-2 group-hover:opacity-70 duration-500 transition-opacity">
              {getDescription({ text: article.textContent })}
            </p>
          )}
        </Link>
      </div>
    </div>
  );
}
